import {
  ITPServicePromiseClient,
  GetUserRequest,
  GetUserScoreRequest,
  UpdateUserRequest,
  GetTodayLeaderboardRequest,
  GetSchoolLeaderboardRequest,
  GetStudentLeaderboardRequest,
  GetSchoolStudentLeaderboardRequest,
  WatchedVideoRequest,
  ListenedPodcastRequest,
  GetUserPlayLogRequest,
  ListAllVideosRequest,
  ListAllPodcastsRequest,
  PingRequest,
} from "./grpc/itp_service_grpc_web_pb";
import { Token } from "./grpc/auth/token_pb";
import { get, set } from "./state";
import useAuth from "./firebase";
import { User } from "./grpc/user_pb";
import { Pathways } from "./grpc/pathway_pb";
import { getPathwayId } from "./utils";

const auth = useAuth();

const client = new ITPServicePromiseClient(
  "https://grpcw.vitalitysouthosting.net"
);
const appId = "d9t!9Xmu$3DU&2qA";

const useGrpc = () => {
  const getUserCredentials = async () => {
    const token = new Token();
    const idToken = await auth.getIdToken();
    token.setFirebaseidtoken(idToken);
    const uid = auth.getUID();

    return {
      token,
      uid,
    };
  };

  const getUserData = async () => {
    try {
      const creds = await getUserCredentials();
      if (!creds) throw new Error("No user credentials");

      const req = new GetUserRequest();
      req.setToken(creds.token);
      req.setAppId(appId);

      const response = await client.getUser(req, {});

      return response.toObject();
    } catch (err) {
      console.error(err);
      return null;
    }
  };

  const getUserScore = async () => {
    try {
      const creds = await getUserCredentials();
      if (!creds) throw new Error("No user credentials");

      const req = new GetUserScoreRequest();
      req.setToken(creds.token);
      req.setAppId(appId);

      const response = await client.getUserScore(req, {});

      return response.toObject();
    } catch (err) {
      console.error(err);
      return null;
    }
  };

  const updateUserData = async (pathways) => {
    try {
      const creds = await getUserCredentials();
      if (!creds) throw new Error("No user credentials");

      if (pathways) {
        const pathwaysList = pathways.map(
          (pathway) => Pathways[getPathwayId(pathway)]
        );

        set("interestedPathways", JSON.stringify(pathwaysList));
      }

      const user = new User();
      user.setEmail(get("email"));
      user.setAccountType(get("accountType"));
      user.setFirstName(get("fname"));
      user.setLastName(get("lname"));
      user.setSchool(get("school"));
      user.setGrade(get("grade"));
      user.setLeaderboardName(get("username"));
      //   user.setPathwaysList(JSON.parse(get("interestedPathways")));
      user.setUserId(get("id"));
      const county = get("county") || "";
      if (county) user.setCounty(get("county") ?? "");
      const pathwaysList = JSON.parse(get("interestedPathways")) || [];
      pathwaysList.forEach((p) => user.addPathways(p));

      const req = new UpdateUserRequest();
      req.setToken(creds.token);
      req.setAppId(appId);
      req.setUser(user);

      console.log(req.toObject());

      const response = await client.updateUser(req, {});

      return response.toObject();
    } catch (err) {
      console.error(err);
      return null;
    }
  };

  const getTodayLeaderboard = async () => {
    try {
      const creds = await getUserCredentials();
      if (!creds) throw new Error("No user credentials");

      const req = new GetTodayLeaderboardRequest();
      req.setToken(creds.token);
      req.setAppId(appId);

      const response = await client.getTodayLeaderboard(req, {});

      return response.toObject();
    } catch (err) {
      console.error(err);
      return null;
    }
  };

  const getSchoolLeaderboard = async () => {
    try {
      const creds = await getUserCredentials();
      if (!creds) throw new Error("No user credentials");

      const req = new GetSchoolLeaderboardRequest();
      req.setToken(creds.token);
      req.setAppId(appId);

      const response = await client.getSchoolLeaderboard(req, {});

      return response.toObject();
    } catch (err) {
      console.error(err);
      return null;
    }
  };

  const getStudentLeaderboard = async () => {
    try {
      const creds = await getUserCredentials();
      if (!creds) throw new Error("No user credentials");

      const req = new GetStudentLeaderboardRequest();
      req.setToken(creds.token);
      req.setAppId(appId);

      const response = await client.getStudentLeaderboard(req, {});

      return response.toObject();
    } catch (err) {
      console.error(err);
      return null;
    }
  };

  const getSchoolStudentLeaderboard = async () => {
    try {
      const creds = await getUserCredentials();
      if (!creds) throw new Error("No user credentials");

      const req = new GetSchoolStudentLeaderboardRequest();
      req.setToken(creds.token);
      req.setAppId(appId);

      const response = await client.getSchoolStudentLeaderboard(req, {});

      return response.toObject();
    } catch (err) {
      console.error(err);
      return null;
    }
  };

  const watchedVideo = async (videoURL, answers) => {
    try {
      const creds = await getUserCredentials();
      if (!creds) throw new Error("No user credentials");

      const req = new WatchedVideoRequest();
      req.setToken(creds.token);
      req.setAppId(appId);
      req.setVideoUrl(videoURL);
      req.setAnswersList(answers);

      const response = await client.watchedVideo(req, {});

      return response.toObject();
    } catch (err) {
      console.error(err);
      return null;
    }
  };

  const listenedPodcast = async (podcastURL, answers) => {
    try {
      const creds = await getUserCredentials();
      if (!creds) throw new Error("No user credentials");

      const req = new ListenedPodcastRequest();
      req.setToken(creds.token);
      req.setAppId(appId);
      req.setPodcastUrl(podcastURL);
      req.setAnswersList(answers);

      const response = await client.listenedPodcast(req, {});

      return response.toObject();
    } catch (err) {
      console.error(err);
      return null;
    }
  };

  const getUserPlayLog = async () => {
    try {
      const creds = await getUserCredentials();
      if (!creds) throw new Error("No user credentials");

      const req = new GetUserPlayLogRequest();
      req.setToken(creds.token);
      req.setAppId(appId);

      const response = await client.getUserPlayLog(req, {});

      return response.toObject();
    } catch (err) {
      console.error(err);
      return null;
    }
  };

  const getAllVideos = async () => {
    try {
      const creds = await getUserCredentials();
      if (!creds) throw new Error("No user credentials");

      const req = new ListAllVideosRequest();
      req.setToken(creds.token);
      req.setAppId(appId);

      const response = await client.listAllVideos(req, {});

      return response.toObject();
    } catch (err) {
      console.error(err);
      return null;
    }
  };

  const getAllPodcasts = async () => {
    try {
      const creds = await getUserCredentials();
      if (!creds) throw new Error("No user credentials");

      const req = new ListAllPodcastsRequest();
      req.setToken(creds.token);
      req.setAppId(appId);

      const response = await client.listAllPodcasts(req, {});

      return response.toObject();
    } catch (err) {
      console.error(err);
      return null;
    }
  };

  const ping = async () => {
    try {
      const req = new PingRequest();
      const res = await client.ping(req, {});
      const obj = res.toObject();
      console.log(obj);
      return obj;
    } catch (err) {
      console.error(err);
      return null;
    }
  };

  return {
    getUserData,
    getUserScore,
    updateUserData,
    getTodayLeaderboard,
    getSchoolLeaderboard,
    getStudentLeaderboard,
    getSchoolStudentLeaderboard,
    getUserPlayLog,
    watchedVideo,
    listenedPodcast,
    getAllVideos,
    getAllPodcasts,
    ping,
  };
};

console.log("grpc.boot");

export default useGrpc;
